import { Directive, inject, ChangeDetectorRef, effect } from '@angular/core';
import { LanguageService } from '../services/language.service';

@Directive({
  selector: '[appLanguageChange]',
  standalone: true
})
export class LanguageChangeDirective {
  private cdr = inject(ChangeDetectorRef);
  private languageService = inject(LanguageService);

  constructor() {
    // Automatically trigger change detection when language changes
    effect(() => {
      this.languageService.languageChanged();
      
      // Also trigger a delayed detection to handle any async translation loading
      setTimeout(() => {
        this.cdr.detectChanges();
      }, 100);
    });
  }
}
